import React  from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import './Color.scss';
import {
    getExteriorColorCode,
    PostcompareData,
    postCompareImages,
    secondaryVehiclesTrims, setActiveLocale, setColorIcon, setCompareDataGroupInfo, setHeaderLoadType,
} from "../../slices/vehicleSlice";
import { useDispatch, useSelector } from "react-redux";
import {
    buildColorTile,
    buildInteriorColorTile,
    getColorName,
    getCurrentExteriorColor,
    getCurrentInteriorColor
} from "./color.methods";
import {trackChangeColorModalEvent, trackColorChanged, trackViewSecondaryVehicleColors} from "../GoogleTagManager.utils";
import {useMediaQuery} from "react-responsive";
import { faTint} from "@fortawesome/free-solid-svg-icons";

import {Modal} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const Color = ({ primaryColor, translate, mediaColor,id, interiorColor }) => {

    const [showModal, setShowModal] = React.useState(false);
    const { t } = useTranslation();
    const { pathname } = window.location;
    const dispatch = useDispatch();
    const trimCodes = useSelector(secondaryVehiclesTrims);
    const [hoverExteriorColor, setHoverExteriorColor] = React.useState('');
    const [hoverInteriorColor, setHoverInteriorColor] = React.useState('');
    const [interior, setInteriorColor] = React.useState('');
    const [exterior, setExteriorColor] = React.useState('');
    const compareGroup = useSelector(setCompareDataGroupInfo)
    const isPrimary = id === 0 || id === "0";
    const isMinWidth = useMediaQuery({ query: '(min-width: 899px)' });
    const isMaxHeight = useMediaQuery({ query: '(max-height: 769px)' });
    const activeLocale = useSelector(setActiveLocale);
    const headerLoadType = useSelector(setHeaderLoadType)

    const handleOpenModal = () => {
        const colorName = hoverExteriorColor? hoverExteriorColor : getColorName(primaryColor, mediaColor)
        setShowModal(true)
        document.body.classList.add('show-modal');
        isPrimary && trackChangeColorModalEvent(compareGroup,colorName)
        !isPrimary && trackViewSecondaryVehicleColors(compareGroup,colorName)
    };

    const removeDuplicateColorCodes = (exteriorColors, colorType ="") => {
        if (id === 0 && colorType === "exterior") {
            return exteriorColors;
        }

        const colorCodes = new Set();
        const colorFamily = new Set();
        const seenPrimaryColorCode = new Set();
        let mediaColorHandled = false;

        return exteriorColors?.filter((color) => {
            if (color?.code) {
                if (color.code === mediaColor && !mediaColorHandled) {
                    mediaColorHandled = true;
                    colorFamily.add(color.family);
                    seenPrimaryColorCode.add(color?.media?.primary);
                    return true;
                }

                if (!seenPrimaryColorCode.has(color?.media.primary) && !colorCodes.has(color.code) && color.family !== 'Unreleased') {
                    colorCodes.add(color.code);
                    colorFamily.add(color.family);
                    seenPrimaryColorCode.add(color?.media?.primary);
                    return true;
                }
            }
            return false;
        });
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setExteriorColor('')
        setInteriorColor('');
    }

    const colorHandler = (event) => {
        const colorType = event.target.getAttribute('data-color-type');
        const exteriorColor = event.target.getAttribute('data-vehicle-exteriorColor');
        const isInteriorColor = colorType === 'interior';

        if (!isInteriorColor ) {
            handleCloseModal();
        }

        if (!isPrimary && !isInteriorColor) {
            setExteriorColor(exteriorColor);
        }

        if (colorType !== 'interior') {
            dispatch(setColorIcon(event.target.style.backgroundColor));
            const colorName = hoverExteriorColor ? hoverExteriorColor : getColorName(primaryColor, mediaColor);
            const code = event.target.id;
            const codes = [];

            trimCodes.forEach((code) => {
                if (code !== undefined && code !== null) {
                    codes.push({ code: code });
                }
            });

            const data = {
                exterior: code,
                code: codes,
            };

            pathname.includes('photos')
                ? dispatch(postCompareImages(data))
                : dispatch(PostcompareData(data));

            dispatch(getExteriorColorCode(code));
            trackColorChanged(compareGroup, colorName);
        } else {
            const interiorColor = event.target.getAttribute('data-vehicle-interiorColor');
            setInteriorColor(interiorColor);
        }
    };

    const handleColorBarHover = (event) => {
        const type = event.target.getAttribute('data-color-type');

        if(type === 'interior') {
            const name = event.target.getAttribute('data-vehicle-interiorColor');
            setHoverInteriorColor(name);
        } else {
            const name = event.target.getAttribute('data-vehicle-exteriorColor');
            setHoverExteriorColor(name);
        }
    };

    const secondaryColorHandler = () => {
       setExteriorColor(hoverExteriorColor)
    }

    return (
        <React.Fragment>
            {isMaxHeight && isMinWidth  && pathname.includes('features') ?
                <React.Fragment>
                    <FontAwesomeIcon icon={faTint}
                                                 className={`btn-colour ${mediaColor === 'NO_COLOR' ? 'btn-color-icon-disabled' : ''}`}
                                                 data-testid="color-button"
                                                 onClick={mediaColor === 'NO_COLOR' ? null : handleOpenModal}
                                                 id="change-color"
                    />
                    <div className="tooltip-color" style={{ width: activeLocale === 'fr-CA' ? '65px' : '' }}>
                        {translate('overview.controls.color')}
                    </div>
                </React.Fragment> :
                <button className={`btn-default btn-colour ${mediaColor === 'NO_COLOR' ? 'btn-color-disabled' : ''}`}
                        data-testid="color-button"
                        onClick={handleOpenModal}
                        disabled={mediaColor === 'NO_COLOR'}
                        title={mediaColor === 'NO_COLOR' ? translate("overview.color.unavailableColor") : null}
                        id="change-color"
                        style={ headerLoadType && (mediaColor === "NO_COLOR") ? {
                            color: '#757575',
                            background: '#CCCCCC',
                            boxShadow: 'none',
                            border: '1px solid #757575',
                            cursor: 'not-allowed'

                        } : null}>
                        {translate('overview.controls.color')}
                </button>
            }

            <Modal
                open={showModal}
                onClose={handleCloseModal}
                disableScrollLock={false}
                hideBackdrop={false}
            >
                <div className="color-modal-container">
                    <div className="color-box">
                        <div className="model-header-title">
                            <button
                                type="button"
                                className={'close-compare'}
                                data-testid="close-button"
                                onClick={handleCloseModal}
                            >
                                <CloseIcon fontSize={'medium'}/>
                            </button>
                            <h3 className={'color-panel-title'} data-testid="modal-title">
                                {t('overview.color.availableColors')}
                            </h3>
                        </div>

                        <div className={"color-box-container"}>
                            <p className="color-type-label"> {id ===0 ?t('overview.color.selectExteriorColor') : t('overview.color.viewExteriorColors')}</p>
                            <div className="color-bar">
                                { removeDuplicateColorCodes(primaryColor,"exterior")?.map((vehicle) => (
                                    <React.Fragment key={`${vehicle.name}-${vehicle.family}`}>
                                        {buildColorTile(
                                            vehicle,
                                            colorHandler,
                                            secondaryColorHandler,
                                            handleColorBarHover,
                                            mediaColor,
                                            setHoverExteriorColor,
                                            removeDuplicateColorCodes(primaryColor),
                                            id
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                            <div className={'color-name'}>
                                {hoverExteriorColor ? hoverExteriorColor : getCurrentExteriorColor(exterior, hoverExteriorColor, primaryColor, mediaColor,id)}
                            </div>
                        </div>

                        <div className={"color-box-container"}>
                            <p className="color-type-label">{ t('overview.color.viewInteriorColors')}</p>
                            <div className="color-bar">
                                { removeDuplicateColorCodes(interiorColor,"interior")?.map((vehicle) => (
                                    <React.Fragment key={`${vehicle.name}-${vehicle.family}`}>
                                        {buildInteriorColorTile(
                                            vehicle,
                                            colorHandler,
                                            handleColorBarHover,
                                            setHoverInteriorColor,
                                            id
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                            <div className="color-name">{getCurrentInteriorColor(interior, hoverInteriorColor)}</div>
                        </div>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    );
};
